// Única fuente versionada para modelos y esfuerzos de razonamiento de Tribunalea.
// Las claves de proveedores y los feature flags permanecen en variables de entorno.

export const AI_MODEL_IDS = Object.freeze({
  GPT_5_6_LUNA: "gpt-5.6-luna",
  GPT_5_6_TERRA: "gpt-5.6-terra",
  GPT_5_6_SOL: "gpt-5.6-sol",
  GPT_5_6_ALIAS: "gpt-5.6",
  GPT_5_4_MINI: "gpt-5.4-mini",
  GPT_AUDIO_1_5: "gpt-audio-1.5",
  TEXT_EMBEDDING_3_LARGE: "text-embedding-3-large",
});

export const AI_REASONING_EFFORTS = Object.freeze({
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  XHIGH: "xhigh",
});

function selection(model, reasoningEffort) {
  return Object.freeze({ model, reasoningEffort });
}

const luna = AI_MODEL_IDS.GPT_5_6_LUNA;
const embedding = AI_MODEL_IDS.TEXT_EMBEDDING_3_LARGE;
const low = AI_REASONING_EFFORTS.LOW;
const medium = AI_REASONING_EFFORTS.MEDIUM;
const high = AI_REASONING_EFFORTS.HIGH;
const xhigh = AI_REASONING_EFFORTS.XHIGH;

export const TRIBUNALEA_AI_CONFIG = Object.freeze({
  embeddings: Object.freeze({ defaultModel: embedding }),
  mentis: Object.freeze({
    justiniano: selection(luna, xhigh),
    audioInput: selection(AI_MODEL_IDS.GPT_AUDIO_1_5, null),
  }),
  whatsapp: Object.freeze({
    customerSupport: selection(AI_MODEL_IDS.GPT_5_4_MINI, low),
  }),
  instrumenta: Object.freeze({
    documentProcessor: selection(luna, high),
    judicialInterest: selection(luna, high),
  }),
  expedienteAi: Object.freeze({
    extraction: selection(luna, medium),
    aggregation: selection(luna, high),
    legacyReasoningEffort: medium,
  }),
  documentEditor: Object.freeze({
    context: selection(luna, low),
    autocomplete: selection(luna, low),
    edit: selection(luna, low),
    embedding: Object.freeze({ model: embedding }),
  }),
});
